/**
 * Feature flags for gradual rollout of new features.
 * 
 * Flags default to false (off). Enable via:
 *   1. localStorage: localStorage.setItem('ff_GRID_ENGINE', 'true')
 *   2. URL param: ?ff_grid_engine=true (dev only)
 *   3. API response (future): per-org feature flags
 */

const isDev = import.meta.env.DEV

function getFlag(key, defaultValue = false) {
  // localStorage override (always checked)
  const stored = localStorage.getItem(`ff_${key}`)
  if (stored === 'true') return true
  if (stored === 'false') return false

  // URL param override (dev only)
  if (isDev) {
    try {
      const params = new URLSearchParams(window.location.search)
      const param = params.get(`ff_${key.toLowerCase()}`)
      if (param === 'true') return true
      if (param === 'false') return false
    } catch {
      // ignore
    }
  }

  return defaultValue
}

export function isGridEngineEnabled() {
  return getFlag('GRID_ENGINE', true)
}
